import React from 'react'
import './password.scss'

export const ChangePassword = () => {
    return (
        <div className="main">
            <div className="container">
                <div className="content">
                    <div className="heading">
                        <h3>Change password</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
